import React from 'react'
import { IconSearch, IconBell, IconSettings } from './icons'

export default function TopRail({ onQuickCalc, onQuickQuote }) {
  return (
    <div className="dashboard-v2-rail">
      <a className="rail-brand" href="#">
        <span className="glyph">H</span>
        H.M.I Portal
      </a>
      <nav className="rail-nav">
        <a className="active">Dashboard</a>
        <a href="/bid-estimation">Estimating</a>
        <a href="/projects">Projects</a>
        <a href="#">Operations</a>
        <a href="/reports">Reports</a>
      </nav>
      <div className="rail-quick-actions">
        <button className="dbtn dbtn-outline dbtn-sm" onClick={onQuickCalc}>
          <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <rect x="4" y="2" width="16" height="20" rx="2" /><line x1="8" y1="6" x2="16" y2="6" /><line x1="8" y1="10" x2="10" y2="10" /><line x1="14" y1="10" x2="16" y2="10" /><line x1="8" y1="14" x2="10" y2="14" /><line x1="14" y1="14" x2="16" y2="14" /><line x1="8" y1="18" x2="16" y2="18" />
          </svg>
          Quick Calculator
        </button>
        <button className="dbtn dbtn-outline dbtn-sm" onClick={onQuickQuote}>
          <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" /><polyline points="14 2 14 8 20 8" /><line x1="12" y1="18" x2="12" y2="12" /><line x1="9" y1="15" x2="15" y2="15" />
          </svg>
          Quick Quote
        </button>
      </div>
      <div className="rail-spacer" />
      <button className="rail-icon-btn" title="Search">
        <IconSearch size={16} />
      </button>
      <button className="rail-icon-btn has-badge" title="Notifications">
        <IconBell size={16} />
      </button>
      <button className="rail-icon-btn" title="Settings">
        <IconSettings size={16} />
      </button>
      <span className="rail-avatar">JC</span>
    </div>
  )
}
